<!--学习认证-->
<template>
    <div class="el-StudyAuthentication">
        <el-row class="page_content">
            <h1 class="head_title_white">
                <span style="color: red;float: left;line-height:40px;font-size: 15px;">
                    <i class="el-icon-warning"></i>
                    20分钟以内的视频会自动连播，20分钟以上的视频，请手动点播。如果切换设备发现没有记录，请点击【主动同步】按钮同步学习记录。
                </span>
                <el-button type="primary" @click="activeSync">主动同步</el-button>
                <el-button type="primary" @click="clearCache">清理缓存</el-button>
                <el-button type="primary" @click="backOff">退 出</el-button>
            </h1>
            <div class="bg_"></div>
            <el-row style="padding-top: 10px;">
                <el-container>
                    <el-aside width="400px">
                        <el-row class="head_title">
                            <span class="limit_line_one" :title="courseName" style="float: left;width: 380px;">{{
                    courseName }}</span>
                            <!-- <span class="zdlb">
                                <span style="margin-right: 4px;margin-top: 2px;float: left;">自动连播</span>
                                <el-switch
                                    v-model="value"
                                    @change="changeAutoPlayStudy"
                                    active-color="#73A1F7">
                                </el-switch>
                            </span> -->
                        </el-row>

                        <!-- <h1 class="head_title" style="background-color: #f3f3f3;color: #000000;">
                            第1章 认识Python软件
                        </h1> -->
                        <el-menu :default-active="active" class="el-menu-vertical-demo" @open="handleOpen"
                            @select="handSelect" :default-openeds=openeds @close="handleClose">
                            <template v-for='(item, index) in leaningInfo.children'>
                                <template v-if="item.children.length == 0">
                                    <el-menu-item :index="index + ''" :key="index"
                                        :disabled="item.tePlanCourseVideoList.length <= 0 || $isEmpty(item.tePlanCourseVideoList) || $isEmpty(item.tePlanCourseVideoList[item.tePlanCourseVideoList.length - 1].courseVideoUrl)">
                                        <el-row>
                                            <el-col :span="12" class="limit_line_one 1">
                                                <!-- {{index == 0?item.title:item.courseName}} -->
                                                <template v-if="item.courseType == 3">
                                                    <div style="padding-left: 10px;">{{ item.courseName }}</div>
                                                </template>
                                                <template v-else>
                                                    {{ item.courseName }}
                                                </template>
                                            </el-col>
                                            <el-col :span="12">
                                                <template
                                                    v-if="active != index && (courseInfoLog[index] == 'OK' || $lookVideo(item.tePlanCourseVideoList))">
                                                    <i class="el-icon-success ywc"></i>
                                                    <span
                                                        style="color: white;float: right;margin-right: 20px;">已完成</span>
                                                </template>
                                                <template v-else>
                                                    <template v-if="item.tePlanCourseVideoList.length > 0">
                                                        （{{
                    active == index + '' ? ' 播放中... ' :
                        $returnMinSecond(item.tePlanCourseVideoList)
                }}）
                                                        <i class="wx"></i>
                                                    </template>
                                                </template>
                                            </el-col>
                                        </el-row>
                                    </el-menu-item>
                                </template>
                                <template v-if="item.children.length > 0">
                                    <el-submenu :index="index + ''">
                                        <template slot="title">
                                            <template v-if="item.tePlanCourseVideoList.length > 0">
                                                <el-row>
                                                    <el-col :span="12" class="limit_line_one">
                                                        {{ item.courseName }}
                                                    </el-col>
                                                    <el-col :span="12">
                                                        <template
                                                            v-if="active != index && (courseInfoLog[index] == 'OK' || $lookVideo(item.tePlanCourseVideoList))">
                                                            <i class="el-icon-success ywc"></i>
                                                            <span
                                                                style="color: white;float: right;margin-right: 20px;">已完成</span>
                                                        </template>
                                                        <template v-else>
                                                            （{{
                    active == index + '' ? ' 播放中... ' :
                        $returnMinSecond(item.tePlanCourseVideoList)
                }}）
                                                            <i class="wx"></i>
                                                        </template>
                                                    </el-col>
                                                </el-row>
                                            </template>
                                            <template v-else>
                                                {{ item.courseName }}
                                            </template>
                                        </template>
                                        <el-menu-item-group v-for="(item1, index1) in item.children" :key="index1">
                                            <el-menu-item :index="index + '_' + index1"
                                                :disabled="item1.tePlanCourseVideoList.length <= 0 || $isEmpty(item1.tePlanCourseVideoList) || $isEmpty(item1.tePlanCourseVideoList[item1.tePlanCourseVideoList.length - 1].courseVideoUrl)">
                                                <span slot="title">
                                                    <el-row>
                                                        <el-col :span="12" class="limit_line_one">
                                                            {{ item1.courseName }}
                                                        </el-col>
                                                        <el-col :span="12">
                                                            <template
                                                                v-if="active == (index + '_' + index1) && (courseInfoLog[index + '_' + index1] == 'OK' || $lookVideo(item1.tePlanCourseVideoList))">
                                                                <i class="el-icon-success ywc"></i>
                                                                <span
                                                                    style="color: #409EFF;float: right;margin-right: 10px;">已完成</span>
                                                            </template>
                                                            <template v-else>
                                                                （{{
                    active == (index + '_' + index1) ? ' 播放中... ' :
                        $returnMinSecond(item1.tePlanCourseVideoList)
                }}）
                                                                <i class="wx"></i>
                                                            </template>
                                                        </el-col>
                                                    </el-row>
                                                </span>
                                            </el-menu-item>
                                        </el-menu-item-group>
                                    </el-submenu>
                                </template>
                            </template>
                        </el-menu>
                    </el-aside>
                    <el-main style="padding-right: 0;">
                        <div v-show="videoShow" style="border: 1px solid #f3f3f3;height: calc(100vh - 175px);min-height: 500px;background-color: black;">
                            <video @timeupdate="onTimeupdate" id="myVideo" ref="myVideo" @play="videoPlay($event)"
                                style="width: 100%;height: 100%;"
                                class="video-js vjs-default-skin vjs-big-play-centered" x-webkit-airplay="allow"
                                poster="" webkit-playsinline playsinline x5-video-player-type="h5"
                                x5-video-player-fullscreen="true" preload="auto">
                                <source type="application/x-mpegURL">
                            </video>
                        </div>
                        <div v-show="moocShow" style="border: 1px solid #f3f3f3;height: calc(100vh - 175px);min-height: 500px;background-color: black;">
                            <!-- 慕课网视频播放 -->
                            <div class="wrap" id="video" style="width: 100%; height: calc(100vh - 175px);min-height: 500px;">

                            </div>
                        </div>
                    </el-main>
                </el-container>
            </el-row>
        </el-row>
        <!--        <face-recognition v-if="recognitionShow" :faceRecognition="faceRecognition" :collectionType="collectionType"-->
        <!--                          :verificationTimes="verificationTimes"-->
        <!--                          :studentPhotoUrl="studentPhotoUrl"-->
        <!--                          pageName="studyPage" :key="timer"></face-recognition>-->
        <face-recognition v-show="visibleFaceModal" :visible="visibleFaceModal"
            :intervalTime="getCurrentFaceConfig.coursePhotoIntervalTime" :skip="getCurrentFaceConfig.courseSkipTimes"
            :faceNumber="faceNumber" :score="getCurrentFaceConfig.courseFaceScore"
            :photoCount="getCurrentFaceConfig.coursePhotoCount" @faceOver="faceRecord" @onSkip="faceOnSkip" />
    </div>
</template>
<script id="vm">
//【学习】
import faceRecognition from "@/components/faceRecognition_K";	//人脸识别
import axios from 'axios';
import {
    getCookieKeyForRoleTag,
    getStorageKeyForRoleTag,
    getStudentInfoKeyForRoleTag,
    getUserIP
} from "../../common/ulit";
import vue from "vue";
import jQuery from 'jquery';
import Console from "@/test/Console";

export default {
    name: "StudyAuthentication",
    components: {
        faceRecognition
    },
    data() {
        const autoPlayStudy = localStorage.getItem('autoPlayStudy');
        const openProgressBar = localStorage.getItem(getStorageKeyForRoleTag("openProgressBar"));	//是否开启进度条：1是 2否
        return {
            openeds: ["-1"], //默认打开的菜单数据组
            active: "-1", //激活菜单的 index
            value: autoPlayStudy === "1",
            timer: '',
            tePlanCourseId: this.$route.query.tePlanCourseId,
            courseName: this.$Base64.decode(this.$route.query.courseName),
            leaningInfo: {},
            videoMap: {}, //视频Map
            onNum: 0,//当前播放的视频位置
            courseVideoUrl: "",
            player: null,
            recognitionShow: false,
            laodShow: true,
            faceRecognition: 1, //是否开启人脸 1是 2否
            collectionType: 1, //采集方式 1不可关闭 2可关闭
            verificationTimes: 10, //验证次数
            studentPhotoUrl: "", //照片地址，优先判断照片地址，如果没有则提示去上传学籍照片等待审核
            courseInfoLog: {}, //课程播放记录
            getNowTime: "", //当前时间戳
            oldTime: 0,
            setInt: "",
            studentId: "",
            log_: ",",
            courseTimeMap: {}, //课程的相应视频播放记录
            watchMaxTime: 0, //用户可观看的最大值
            //===========K=>
            ip: undefined,//当前登录用户的IP
            visibleFaceModal: false,//控制人脸识别弹框是否显示
            timer_intervalFaceCheck: null,//间隔调起人脸，定时器
            faceNumber: 0,//人脸识别次数
            //<=K===========
            openProgressBar:openProgressBar, //是否开启进度条：1是 2否
            videoShow:false,
            moocShow:false,
            // 慕课网信息
            moocPlayer:null,
            moocVideoId:null,
            options:{
                appId:null, //产品appId
                moocVideoId:null, //视频ID
                nonce:null,
                signature:null, //签名
                timestamp:null,
                videoSignature:null
            },
            optionsInfo:{

            },

            onOldTime:0,
            nextTime:0,
            timeInterval:30, //视频播放上传记录间隔值 s
            isNewSave:window.configs.isNewSave || true //是否调用新的视频保存方法 ： 默认关闭
        };
    },
    computed: {
        getStudentInfoByLocal() {
            return JSON.parse(sessionStorage.getItem(getStudentInfoKeyForRoleTag())) || {};
        },
        getStudentId() {
            return this.getStudentInfoByLocal.studentId;
        },
        getStudentSource() {
            //学生图片
            return this.getStudentInfoByLocal.studentSource;
        },
        getBelongsProject() {
            return this.leaningInfo.allProfessionalName;
        },
        getCurrentCourse() {
            //当前课程
            return this.leaningInfo.tePlanCourseId;
        },
        getFaceRecognitionSetting() {
            return this.$store.getters['faceRecognition/getAll']
        },
        getCurrentFaceConfig() {
            //当前课程对应的权限
            const allAuth = this.getFaceRecognitionSetting;
            if (!Array.isArray(allAuth)) {
                return null;
            }
            const obj = allAuth.find(item => item.courseId === this.getCurrentCourse) || {};
            console.log("当前课程对应权限", obj)
            return {
                ...obj,
                studentPhotoUrl: this.studentPhotoUrl
            }
        },
    },
    watch: {},
    created() {
        if (this.$isEmpty(this.tePlanCourseId)) {
            this.$message({
                message: "课程数据丢失，请返回上一页！",
                type: 'warning'
            });
        } else {
            let this_ = this;
            // let s = Number(60 + Math.round(Math.random() * 10)) * 1000;
            //是否播放完成的标记
            if (!this.$isEmpty(localStorage.getItem(getStorageKeyForRoleTag("courseInfoLog_") + this.tePlanCourseId))) {
                this.courseInfoLog = JSON.parse(localStorage.getItem(getStorageKeyForRoleTag("courseInfoLog_") + this.tePlanCourseId));
                if (this.courseInfoLog == null || this.courseInfoLog == "") {
                    this.courseInfoLog = {};
                }
            }
            //当前课程的播放时间记录
            if (!this.$isEmpty(localStorage.getItem(getStorageKeyForRoleTag("courseTimeMap_") + this.tePlanCourseId))) {
                this.courseTimeMap = JSON.parse(localStorage.getItem(getStorageKeyForRoleTag("courseTimeMap_") + this.tePlanCourseId));
                if (this.courseTimeMap == null || this.courseTimeMap == "") {
                    this.courseTimeMap = {};
                }
            }
            //上次播放的位置
            let currentActive = localStorage.getItem(getStorageKeyForRoleTag("currentActive_") + this.tePlanCourseId);
            if (!this.$isEmpty(currentActive)) {
                this.active = currentActive;
            }
            this.leaning(); //加载信息
            this.getNowDate(); //获取时间
        }
    },
    mounted() {
        getUserIP((ip) => {
            //获取当前登录用户的IP地址
            this.ip = ip;
        })
    },
    beforeDestroyed() {
        clearInterval(this.timer_intervalFaceCheck);
        this.timer_intervalFaceCheck = null;
    },
    methods: {
        faceOnSkip() {
            //开启了人脸识别跳过，并且达到了次数时触发
            this.visibleFaceModal = false;
            this.player.play();
        },
        faceRecord(validateBool, imgPath) {
            console.log("人脸识别结果", validateBool, imgPath)
            // 如果是1，就是成功，清除定时器
            if (validateBool === 1 || validateBool === '1') {
                this.faceNumber = 0;
                clearInterval(this.timer_intervalFaceCheck);
                this.timer_intervalFaceCheck = null;
            }
            //进行人脸识别记录
            this.player.play();
            this.visibleFaceModal = false;
            const { grade, semesters } = this.leaningInfo;
            const params_record = {
                studentId: this.getStudentId,
                courseId: this.getCurrentCourse,
                photoType: "1",
                photoUrl: imgPath,
                ipAddress: this.ip,
                faceResult: validateBool ? '1' : '-1',
                belongsProject: this.getBelongsProject,//所属项目（xxx课件学习，xxx考试等信息）
                grade,
                semesters
            };
            this.$store.dispatch('user/face_record', params_record);
        },
        activeSync() { //主动同步 2:主动同步
            this.$getClientNeedStudyLog(2);
        },
        clearCache() { //清理缓存：上传先同步，同步成功后再清理缓存
            this.$confirm("是否确定清理缓存？", "提示", {
                confirmButtonText: "确定",
                cancelButtonText: "取消",
                type: "warning",
            }).then(() => {
                setTimeout(() => {
                    this.$getClientNeedStudyLog(2, "clear");
                }, 200)
            }).catch(() => { });

        },
        backOff() { //退出
            // this.player.pause();
            // if (this.getCurrentFaceConfig.courseOutstate === 1) {
            //     //根据配置决定是否在点击退出后开启人脸识别
            //     this.visibleFaceModal = true;
            // }
            // this.$watch(() => this.visibleFaceModal, (bool) => {
            //     if (bool === false) {
            //         this.$router.back();
            //     }
            // })
            this.$router.back();

            // this.$router.go(-1);
        },
        handleOpen(key, keyPath) {
            let time = this.getInitialTime(key);
            const site = this.videoMap[key]; //获取当前点击菜单视频所在的位置
            if (!this.$isEmpty(this.videoMap[key]) || site == 0) {
                this.onNum = site;//当前播放的视频位置
                this.active = key + '';
                this.heaLoad(this.videoMap[site + "url"].url, time);
            }
        },
        handSelect(key, keyPath) {
            let time = this.getInitialTime(key);
            const site = this.videoMap[key]; //获取当前点击菜单视频所在的位置
            if (!this.$isEmpty(this.videoMap[key]) || site == 0) {
                this.active = key + '';
                this.onNum = site;//当前播放的视频位置
                this.heaLoad(this.videoMap[site + "url"].url, time);
            }
        },
        handleClose(key, keyPath) {
            let time = this.getInitialTime(key);
            const site = this.videoMap[key]; //获取当前点击菜单视频所在的位置
            if (!this.$isEmpty(this.videoMap[key]) || site == 0) {
                this.active = key + '';
                this.onNum = site;//当前播放的视频位置
                this.heaLoad(this.videoMap[site + "url"].url, time);
            }
        },
        handleLoad() { //用于重载人脸识别组件
            this.timer = new Date().getTime()
        },
        leaning() { //开始学习
            const loading = this.$loading({
                lock: true,
                text: '加载中......',
                spinner: 'el-icon-loading',
                background: 'rgba(0, 0, 0, 0.7)'
            });
            this.$store.dispatch("user/leaning", { tePlanCourseId: this.tePlanCourseId }).then((ret) => {
                loading.close();
                if (ret.code === 0 || ret.code === '0') {
                    let studentInfo = sessionStorage.getItem(getStudentInfoKeyForRoleTag());
                    this.studentId = JSON.parse(studentInfo).studentId;
                    sessionStorage.clear();
                    sessionStorage.setItem(getStudentInfoKeyForRoleTag(), studentInfo);
                    this.recognitionShow = true;
                    const {
                        faceRecognition,
                        collectionType,
                        verificationTimes,
                        studentPhotoUrl
                    } = ret.faceRecognitionInfo;
                    this.faceRecognition = faceRecognition; //是否开启人脸 1是 2否
                    this.collectionType = collectionType; //采集方式 1不可关闭 2可关闭
                    this.verificationTimes = verificationTimes; //验证次数
                    this.studentPhotoUrl = studentPhotoUrl; //照片地址，优先判断照片地址，如果没有则提示去上传学籍照片等待审核
                    this.leaningInfo = ret.teachingPlanCourse;
                    // if (!studentPhotoUrl) {
                    //     this.$message({
                    //         message: "未上传学籍照片，请先上传学籍照片等待审核！",
                    //         type: 'warning',
                    //         onClose: () => {
                    //             this.$router.go(-1);
                    //         }
                    //     });
                    //     return;
                    // }
                    /*
                    * 2023年7月5日 14:09:45
                    * 获取这门课的人脸识别的各种权限 =>
                    * */
                    const tePlanCourseId = ret.teachingPlanCourse.tePlanCourseId;
                    // const findStoreConfigItem = this.$store.commit('faceRecognition/findItem', tePlanCourseId);
                    // if (findStoreConfigItem) {
                    //     (this.visibleFaceModal = true);
                    // } else {
                    /*
                    * 2023年8月10日 11点36分
                    * TODO:打包到线上，暂时先不调用这个接口
                    *
                    * */
                    this.$store.dispatch('user/getFaceSetting', tePlanCourseId).then(res => {
                        console.log("current play course faceAuth", res)
                        const { code, data } = res;
                        if (code === 0) {
                            const faceConfig = data[0];//Object
                            console.log("this.$store.commit('faceRecognition/add', faceConfig);", faceConfig);
                            this.$store.commit('faceRecognition/add', faceConfig);
                            const { courseFaceSwitch, coursePhotoIntervalTime } = this.getCurrentFaceConfig;
                            if (courseFaceSwitch !== 1) {
                                //closed
                                return;
                            }
                            this.visibleFaceModal = faceConfig.courseInstate === 1;//初始化开启人脸识别
                            if (courseFaceSwitch === 1) {
                                //需要间隔吊起人脸
                                const interval = Number.isInteger(coursePhotoIntervalTime) ? coursePhotoIntervalTime * 60 * 1000 : 0;
                                this.timer_intervalFaceCheck = setInterval(() => {
                                    if (this.visibleFaceModal === false) {
                                        this.player.pause();//暂停视频播放
                                        this.visibleFaceModal = true;
                                        this.faceNumber++;
                                    }
                                }, interval)
                            }


                            this.$forceUpdate();
                            console.log("是否初始化开启人脸识别", faceConfig)
                            // faceConfig.courseInstate === 1 && (this.visibleFaceModal = true);
                        }
                    })
                    // }
                    if (ret.teachingPlanCourse.children.length > 0) {
                        let num = 0;
                        ret.teachingPlanCourse.children.forEach((ele, i) => {
                            if (ele.tePlanCourseVideoList.length > 0) {
                                this.videoMap[`${i}`] = num;
                                let localTime = this.courseTimeMap[`${i}`];//获取当前视频本地缓存的时间(单位秒)
                                let serverTime = ele.tePlanCourseVideoList[ele.tePlanCourseVideoList.length - 1].tsTime; //服务器的播放记录时间(单位毫秒)
                                if (!this.$isEmpty(localTime)) {
                                    localTime = Number(localTime) * 1000;
                                }
                                if (!this.$isEmpty(localTime) && !this.$isEmpty(serverTime)) { //都不为空时就进入判断 取值（从后端拿，没有的，用后端的，比缓存时间大的，用后端，其他的用前端的，然后都以前端为准）
                                    let len = this.leaningInfo.children[i].tePlanCourseVideoList;
                                    if (localTime < Number(serverTime)) {
                                        this.leaningInfo.children[i].tePlanCourseVideoList[len.length - 1].tsTime = serverTime;
                                    } else {
                                        this.leaningInfo.children[i].tePlanCourseVideoList[len.length - 1].tsTime = localTime;
                                    }
                                } else if (!this.$isEmpty(localTime) || !this.$isEmpty(serverTime)) {
                                    let len = this.leaningInfo.children[i].tePlanCourseVideoList;
                                    if (this.$isEmpty(localTime)) {
                                        this.leaningInfo.children[i].tePlanCourseVideoList[len.length - 1].tsTime = serverTime;
                                    } else if (this.$isEmpty(serverTime)) {
                                        this.leaningInfo.children[i].tePlanCourseVideoList[len.length - 1].tsTime = localTime;
                                    }
                                }
                                const tePlanCourseVideoList = ele.tePlanCourseVideoList || [];
                                const tePlanCourseVideoList_len = tePlanCourseVideoList.length - 1 || 0;
                                const tePlanCourseVideoItem = tePlanCourseVideoList[tePlanCourseVideoList_len] || {};
                                this.videoMap[num + 'url'] = {
                                    url: tePlanCourseVideoItem.courseVideoUrl,
                                    tePlanCourseId: tePlanCourseVideoItem.tePlanCourseId,
                                    tePlanCourseVideoId: tePlanCourseVideoItem.tePlanCourseVideoId,
                                    active: i,
                                    courseVideoTime: tePlanCourseVideoItem.courseVideoTime,
                                    tsTime: tePlanCourseVideoItem.tsTime,
                                    videoId:tePlanCourseVideoItem.videoId
                                };  //key:当前位置+url = 视频url
                                num = num + 1;
                                if (num == 1) {
                                    this.openeds = [`${i}`];
                                }
                            }
                            if (ele.children.length > 0) {
                                ele.children.forEach((el, index) => {
                                    if (el.tePlanCourseVideoList.length > 0) {
                                        this.videoMap[`${i}` + '_' + `${index}`] = num;
                                        let localTime = this.courseTimeMap[`${i}` + '_' + `${index}`];//获取当前视频本地缓存的时间(单位秒)
                                        let serverTime = el.tePlanCourseVideoList[el.tePlanCourseVideoList.length - 1].tsTime; //服务器的播放记录时间(单位毫秒)
                                        if (!this.$isEmpty(localTime)) {
                                            localTime = Number(localTime) * 1000;
                                        }
                                        if (!this.$isEmpty(localTime) && !this.$isEmpty(serverTime)) { //都不为空时就进入判断 取值（从后端拿，没有的，用后端的，比缓存时间大的，用后端，其他的用前端的，然后都以前端为准）
                                            let len = this.leaningInfo.children[i].children[index].tePlanCourseVideoList;
                                            if (localTime < Number(serverTime)) {
                                                this.leaningInfo.children[i].children[index].tePlanCourseVideoList[len.length - 1].tsTime = serverTime;
                                            } else {
                                                this.leaningInfo.children[i].children[index].tePlanCourseVideoList[len.length - 1].tsTime = localTime;
                                            }
                                        } else if (!this.$isEmpty(localTime) || !this.$isEmpty(serverTime)) {
                                            let len = this.leaningInfo.children[i].children[index].tePlanCourseVideoList;
                                            if (this.$isEmpty(localTime)) {
                                                this.leaningInfo.children[i].children[index].tePlanCourseVideoList[len.length - 1].tsTime = serverTime;
                                            } else if (this.$isEmpty(serverTime)) {
                                                this.leaningInfo.children[i].children[index].tePlanCourseVideoList[len.length - 1].tsTime = localTime;
                                            }
                                        }
                                        this.videoMap[num + 'url'] = {
                                            url: el.tePlanCourseVideoList[el.tePlanCourseVideoList.length - 1].courseVideoUrl,
                                            tePlanCourseId: el.tePlanCourseVideoList[el.tePlanCourseVideoList.length - 1].tePlanCourseId,
                                            tePlanCourseVideoId: el.tePlanCourseVideoList[el.tePlanCourseVideoList.length - 1].tePlanCourseVideoId,
                                            active: `${i}` + '_' + `${index}`,
                                            courseVideoTime: el.tePlanCourseVideoList[el.tePlanCourseVideoList.length - 1].courseVideoTime,
                                            tsTime: el.tePlanCourseVideoList[el.tePlanCourseVideoList.length - 1].tsTime,
                                            videoId:el.tePlanCourseVideoList[el.tePlanCourseVideoList.length - 1].videoId
                                        }
                                        //key:当前位置+url = 视频url
                                        num = num + 1;
                                        if (num == 1 && this.active == "-1") {
                                            this.openeds = [`${i}`];
                                            this.active = `${i}` + '_' + `${index}`;
                                        }
                                    }
                                });
                            }
                        });

                        this.initVideo();
                    }
                } else {
                    this.$message({
                        message: ret.msg,
                        type: 'warning'
                    });
                }
            }).catch(() => {
                loading.close();
            });
        },
        initVideo() {
            //初始化视频方法
            let site = 0; //获取播放的位置num
            if (this.active == '-1') {
                this.active = this.videoMap["0url"].active + '';
            } else {
                site = this.videoMap[this.active]; //当前播放的位置
                this.onNum = site;
            }
            if(!this.$isEmpty(this.videoMap[this.onNum + "url"].videoId)){ //根据videoId判断是慕课网还是自己的视频
                //加载慕课网
                this.moocVideoId = this.videoMap[this.onNum + "url"].videoId; //视频ID
                this.moocShow = true;
                this.getOptions();
            }else{
                //加载本地视频播放器
                this.videoShow = true;
                this.loadVideo();
            }

        },
        loadVideo(){ //加载本地视频
            setTimeout(()=>{
                let this_ = this;
                this.player = this.$video(myVideo, {
                    //确定播放器是否具有用户可以与之交互的控件。没有控件，启动视频播放的唯一方法是使用autoplay属性或通过Player API。
                    controls: true,
                    //自动播放属性,muted:静音播放
                    autoplay: false,
                    //建议浏览器是否应在<video>加载元素后立即开始下载视频数据。
                    preload: "auto",
                    autoDisable: true,
                    //设置视频播放器的显示宽度（以像素为单位）
                    // playbackRates: [0.5, 1, 1.5, 2],
                    sources: [ // 视频源
                        {
                            src: this.$isHttp(this.videoMap[this_.onNum + "url"].url),
                            // src:  "http://192.168.0.106:9090/server/filesystem/temp/m3u8/test.m3u8",
                            // src: "http://clips.vorwaerts-gmbh.de/big_buck_bunny.mp4",//TODO 测试地址，测试当视频播放过程中到达人脸识别时间，暂停视频
                            // src: "http://playertest.longtailvideo.com/adaptive/bipbop/gear4/prog_index.m3u8",
                            poster: ''
                        }]
                },
                    function onPlayerReady() {
                        console.log("%c onPlayerReady", "background:green");

                        let time = this_.getInitialTime(this_.videoMap[this_.onNum + "url"].active);
                        let tsTime = this_.videoMap[this_.onNum + "url"].tsTime / 1000; //已拨时长
                        if (time != 0 && !this_.$isEmpty(time)) {
                            this.currentTime(time); //设置开始播放位置
                            /*
                            * 2023年7月10日10:30:01
                            * 需求：视频初始化之后就设置所有的视频状态为已完成
                            * */
                            // setTimeout(() => {
                            //     const keys = Object.keys(this_.videoMap);
                            //     const len = parseInt(keys.length / 2);
                            //     const tempObj = {};
                            //     for (let i = 0; i < len; i++) {
                            //         tempObj[i] = 'OK';
                            //     }
                            //     this_.courseInfoLog = tempObj;
                            //     this_.$forceUpdate();
                            // }, 1000)
                        }
                        this_.watchMaxTime = tsTime; //写入最大允许播放值
                        this.on("loadstart", function () {
                            console.log("开始请求数据 ");
                        });
                    });
                jQuery("#myVideo").ready(() => {
                    this.makeTheVideoClearer(this.player);
                });
                jQuery('video').bind('contextmenu', function () {
                    return false;
                }); //禁止右键

                // if (this.$baseUrl.indexOf("lfjtysxx") < 0) { //只有廊坊交通运输学校显示进度条
                //     jQuery('.vjs-progress-control').hide();//隐藏进度条
                // }
                jQuery('.vjs-progress-control').hide();//隐藏进度条
            },200);
        },
        makeTheVideoClearer(player) {
            /*
        * TODO:解决视频清晰度的问题
        *  2023年8月17日 10点14分
        * */
            const videoDom = this.$refs.myVideo;

            function getWidth(videoWidth) {
                /*
                * 取最合适的范围：根据视频宽度计算出最合适的宽度
                * 视频宽高：1920 1084
                * 元素宽高：1200 600
                * 宽度最合适的范围：乘除操作后大于零且最接近1200的值
                *
                * */
                if (typeof videoWidth !== 'number' || videoWidth < 0) return;
                const iframeWidth = 1200;//[600,1200]
                let width = 960;
                if (videoWidth > 600 && videoWidth < 1200) {
                    width = videoWidth;
                } else if (videoWidth > 0 && videoWidth <= 600) {
                    let _width = videoWidth;
                    while (_width < iframeWidth) {
                        const cacheWidth = _width;
                        _width = _width << 1;
                        if (_width > iframeWidth) {
                            _width = cacheWidth;
                            break;
                        }
                    }
                    width = _width;
                } else {
                    let _width = videoWidth;
                    while (_width > iframeWidth) {
                        _width = _width >> 1
                    }
                    width = _width;
                }
                return width;
            }

            function checkIsFullScreen() {
                var isFullScreen = document.fullscreen || document.mozFullScreen || document.webkitIsFullScreen;
                return isFullScreen == undefined ? false : isFullScreen;
            }

            function setVideoAutoSize(videoDom) {
                //设置最合适的分辨率
                const { videoWidth, videoHeight } = videoDom;//1920 1084
                const width = getWidth(videoWidth);
                // videoDom.style.width = (videoWidth >> 1) + 'px';
                videoDom.style.width = width + "px";
                videoDom.style.height = '100%';
                videoDom.classList.add("videoOffset");
            }


            player.on('fullscreenchange', (e) => {
                const hasFullScreen = checkIsFullScreen();
                if (hasFullScreen) {
                    videoDom.style.width = 'auto';
                    videoDom.style.height = '100vh';
                } else {
                    setVideoAutoSize(videoDom);
                }
            })

            player.on('loadedmetadata', () => {
                setVideoAutoSize(videoDom);
            })
        },
        heaLoad(url, time, tag) {
            this.nextTime = 0;
            // if(this.onNum == 3){
            //     this.videoMap[this.onNum + "url"].videoId = "";
            // }
            // console.log(this.videoMap[this.onNum + "url"].videoId)
            if(!this.$isEmpty(this.videoMap[this.onNum + "url"].videoId)){ //根据videoId判断是慕课网还是自己的视频
                //加载慕课网
                if(!this.$isEmpty(this.moocPlayer)){
                    this.moocPlayer.destroy(); //销毁
                }
                if(!this.$isEmpty(this.player)){
                    this.player.pause();; //暂停
                }

                this.moocVideoId = this.videoMap[this.onNum + "url"].videoId; //视频ID
                this.videoShow = false;
                this.moocShow = true;
                this.getOptions(tag || 1);
            }else{
                //加载慕课网
                if(!this.$isEmpty(this.moocPlayer)){
                    this.moocPlayer.destroy(); //销毁
                }
                this.moocShow = false;
                this.videoShow = true;
                if(this.$isEmpty(this.player)){
                    this.loadVideo();
                }else{
                    localStorage.setItem(getStorageKeyForRoleTag("currentActive_") + this.tePlanCourseId, this.active);
                    this.log_ = ",";
                    if (!this.$isEmpty(url)) {
                        this.player.src(this.$isHttp(url));

                        // let currentTime = sessionStorage.getItem("currentTime_"+this.onNum); //获取上一次播放的时间
                        // if(!this.$isEmpty(currentTime)){
                        //   if(!this.getCompleteTime(this.active,currentTime)){
                        //     this.player.currentTime(currentTime); //设置开始播放位置
                        //   }
                        // }else{
                        //   if(time != 0 && !this.$isEmpty(time)){
                        //     this.player.currentTime(time); //设置开始播放位置
                        //   }
                        // }
                        if (time != 0 && !this.$isEmpty(time)) {
                            this.player.currentTime(time); //设置开始播放位置
                        }
                        let tsTime = this.videoMap[this.onNum + "url"].tsTime / 1000; //已拨时长
                        this.watchMaxTime = tsTime; //写入最大允许播放值
                        if (tag == 2) { //播放完成时判断下一个视频大小，如果小于20分钟自动播放
                            if (Number(this.videoMap[this.onNum + "url"].courseVideoTime) <= (1000 * 60 * 21) || this.value) {
                                this.player.play(); //播放
                            } else { //大于20分钟时间 只有廊坊交通运输学校自动播放
                                if (this.$baseUrl.indexOf("lfjtysxx") >= 0) { //只有廊坊交通运输学校
                                    this.player.play(); //播放
                                }
                            }
                        } else {
                            this.player.play(); //播放
                        }
                        // this.player.src("http://192.168.0.106:9090/server/filesystem/temp/m3u8/test.m3u8");
                    } else {
                        this.$message({
                            message: "该章节没有在线课程",
                            type: 'warning'
                        });
                    }
                }

            }
        },
        videoPlay() { //视频开始播放了
            if(this.openProgressBar == 1 && (this.$lookVideo([this.videoMap[this.onNum + "url"]]) || this.courseInfoLog[`${this.active}`] == 'OK')){ //表示已播放 完成  展示进度条
                jQuery('.vjs-progress-control').show();//显示进度条
            }else{
                jQuery('.vjs-progress-control').hide();//隐藏进度条
            }
            const videoInfo = this.videoMap[this.onNum + 'url']
            if (videoInfo != null && videoInfo.tePlanCourseId != null) {
                this.$getMessageAccept(videoInfo.tePlanCourseId);
            }
        },
        onTimeupdate(e) { //判断是否播放完成
            if (this.$baseUrl.indexOf("lfjtysxx") >= 0) { //只有廊坊交通运输学校能快退不能快进
                let time = e.target.currentTime;
                if (time > this.watchMaxTime && time - this.watchMaxTime < 2) {
                    this.watchMaxTime = time;
                } else if (time - this.watchMaxTime > 2) {
                    this.player.currentTime(this.watchMaxTime);
                    return;
                }
            }

            //根据timeInterval进行分片  【开始】
            if (e.target.currentTime > 0 && this.getNowTime % 1000 == 0 && this.onOldTime < this.getNowTime) { //一秒一次
                this.onOldTime = this.getNowTime;
                const currentTime = Math.floor(e.target.currentTime);
                if(currentTime % this.timeInterval == 1){ //写入分片开始值
                    this.nextTime = currentTime - 1;
                }
                if(currentTime % this.timeInterval == 0 && this.isNewSave){ //到上传播放记录的时候啦
                    if(currentTime - this.nextTime == this.timeInterval){ //对了 对了  当前时间-分片上次的时间 = 设置的间隔时间
                        const paramLog = {
                            startTime:this.nextTime * 1000,
                            endTime:currentTime * 1000,
                            tePlanCourseVideoId:this.videoMap[this.onNum + "url"].tePlanCourseVideoId,
                            url:this.videoMap[this.onNum + "url"].url,
                            courseVideoTime:Math.floor(this.videoMap[this.onNum + "url"].courseVideoTime)
                        }
                        this.saveLog(paramLog);
                    }
                }
            }
            if (e.target.currentTime == e.target.duration && this.isNewSave) { //播放完成
                const paramLog = {
                    startTime:this.nextTime * 1000,
                    endTime:Math.floor(this.videoMap[this.onNum + "url"].courseVideoTime),
                    tePlanCourseVideoId:this.videoMap[this.onNum + "url"].tePlanCourseVideoId,
                    url:this.videoMap[this.onNum + "url"].url,
                    courseVideoTime:Math.floor(this.videoMap[this.onNum + "url"].courseVideoTime)
                }
                this.saveLog(paramLog);
            }
            //根据timeInterval进行分片  【结束】


            if (e.target.currentTime > 0 && this.getNowTime % 2000 == 0 && this.oldTime < this.getNowTime) {
                this.oldTime = this.getNowTime;

                //判断是否出现了弹出系统消息对话框  ， 如果出现了则停止视频播放
                let newTag = localStorage.getItem(getStorageKeyForRoleTag("new_index_tag")); //表是已有页面展示了消息对话框
                if (newTag == "OK") {
                    (typeof this.player.pause === 'function') && this.player.pause(); //暂停视频
                    return;
                }
            }
            if (e.target.currentTime > 5) {
                //当前课程的播放时间记录
                if (!this.$isEmpty(localStorage.getItem(getStorageKeyForRoleTag("courseTimeMap_") + this.tePlanCourseId))) {
                    this.courseTimeMap = JSON.parse(localStorage.getItem(getStorageKeyForRoleTag("courseTimeMap_") + this.tePlanCourseId));
                    if (this.courseTimeMap == null || this.courseTimeMap == "") {
                        this.courseTimeMap = {};
                    }
                }
                this.getAndSetTime(this.active, Math.floor(e.target.currentTime) * 1000); //同步至当前页面课程树结构list
                this.courseTimeMap[`${this.active}`] = Math.floor(e.target.currentTime); //存入当前播放的位置
                localStorage.setItem(getStorageKeyForRoleTag("courseTimeMap_") + this.tePlanCourseId, JSON.stringify(this.courseTimeMap));
                // sessionStorage.setItem("currentTime_"+this.onNum,Math.floor(e.target.currentTime)); //临时存储当前播放的时间根据位置存储
            }

            if (e.target.currentTime == e.target.duration || (Number(e.target.currentTime) + 5) >= e.target.duration) { //时间相等说明播放完毕  && this.value 【为什么加上5秒，是因为反显时，相差5秒也会显示已完成】
                //是否播放完成的标记
                if (!this.$isEmpty(localStorage.getItem(getStorageKeyForRoleTag("courseInfoLog_") + this.tePlanCourseId))) {
                    this.courseInfoLog = JSON.parse(localStorage.getItem(getStorageKeyForRoleTag("courseInfoLog_") + this.tePlanCourseId));
                    if (this.courseInfoLog == null || this.courseInfoLog == "") {
                        this.courseInfoLog = {};
                    }
                }
                this.courseInfoLog[`${this.active}`] = "OK"; //表示已播放完成
                localStorage.setItem(getStorageKeyForRoleTag("courseInfoLog_") + this.tePlanCourseId, JSON.stringify(this.courseInfoLog));
                if (e.target.currentTime == e.target.duration){
                    if (this.getCurrentFaceConfig.courseOutstate === 1) {
                        console.log("播放完成时开启人脸识别！")
                        //根据配置决定是否在播放完成后开启人脸识别
                        this.visibleFaceModal = true;
                        this.$forceUpdate();
                    }
                    if (!this.$isEmpty(this.videoMap[((Number(this.onNum) + 1) + '') + "url"])) {
                        this.onNum = Number(this.onNum) + 1;
                        if (!this.$isEmpty(this.videoMap[this.onNum + "url"].url)) {
                            this.active = this.videoMap[this.onNum + "url"].active + '';
                            let time = this.getInitialTime(this.active);
                            this.heaLoad(this.videoMap[this.onNum + "url"].url, time, 2);
                        } else {
                            this.onNum = Number(this.onNum) - 1;
                        }
                    }
                }
            }
        },
        changeAutoPlayStudy(key) { //监听自动连播开关
            this.value = key;
            localStorage.setItem(getStorageKeyForRoleTag('autoPlayStudy'), key == true ? 1 : 2);
        },
        getInitialTime(key) { //获取当前视频之前播放的位置
            let initial_time = "";
            if ((key + '').split("_").length == 2) {
                let a = (key + '').split("_")[0];
                let b = (key + '').split("_")[1];
                let info = this.leaningInfo.children[`${a}`].children[`${b}`];
                if (!this.$lookVideo(info.tePlanCourseVideoList)) { //如果是已完成的视频则从头开始播放
                    if (info.tePlanCourseVideoList.length > 0) {
                        initial_time = info.tePlanCourseVideoList[info.tePlanCourseVideoList.length - 1].tsTime;
                    }
                }

            } else if ((key + '').split("_").length == 1) {
                let info = this.leaningInfo.children[`${key}`];
                if (!this.$lookVideo(info.tePlanCourseVideoList)) {//如果是已完成的视频则从头开始播放
                    if (info.tePlanCourseVideoList.length > 0) {
                        initial_time = info.tePlanCourseVideoList[info.tePlanCourseVideoList.length - 1].tsTime;
                    }
                }
            }
            if (initial_time == 0 || this.$isEmpty(initial_time)) {
                initial_time = "";
            } else {
                initial_time = initial_time / 1000;
                if (initial_time > 10) {
                    // initial_time = initial_time - 5;
                    initial_time = initial_time;
                }
            }
            return initial_time;
        },
        getCompleteTime(key, currentTime) {
            let initial_time = "";
            if ((key + '').split("_").length == 2) {
                let a = (key + '').split("_")[0];
                let b = (key + '').split("_")[1];
                let info = this.leaningInfo.children[`${a}`].children[`${b}`];
                if (this.$isEmpty(info.tePlanCourseVideoList[info.tePlanCourseVideoList.length - 1].courseVideoTime) || Number(info.tePlanCourseVideoList[info.tePlanCourseVideoList.length - 1].courseVideoTime) <= ((Number(currentTime) + 5) * 1000)) {
                    return true;
                } else {
                    return false;
                }
            } else if ((key + '').split("_").length == 1) {
                let info = this.leaningInfo.children[`${key}`];
                if (this.$isEmpty(info.tePlanCourseVideoList[info.tePlanCourseVideoList.length - 1].courseVideoTime) || Number(info.tePlanCourseVideoList[info.tePlanCourseVideoList.length - 1].courseVideoTime) <= ((Number(currentTime) + 5) * 1000)) {
                    return true;
                } else {
                    return false;
                }
            }
        },
        getAndSetTime(key, time) { //只获取当前播放视频
            let initial_time = "";
            if ((key + '').split("_").length == 2) {
                let a = (key + '').split("_")[0];
                let b = (key + '').split("_")[1];
                let info = this.leaningInfo.children[`${a}`].children[`${b}`];
                if (info.tePlanCourseVideoList.length > 0) {
                    initial_time = info.tePlanCourseVideoList[info.tePlanCourseVideoList.length - 1].tsTime;
                    if (!this.$isEmpty(time)) {
                        info.tePlanCourseVideoList[info.tePlanCourseVideoList.length - 1].tsTime = time;
                    }
                }
            } else if ((key + '').split("_").length == 1) {
                let info = this.leaningInfo.children[`${key}`];
                if (info.tePlanCourseVideoList.length > 0) {
                    initial_time = info.tePlanCourseVideoList[info.tePlanCourseVideoList.length - 1].tsTime;
                    if (!this.$isEmpty(time)) {
                        info.tePlanCourseVideoList[info.tePlanCourseVideoList.length - 1].tsTime = time;
                    }
                }
            }
            if (initial_time > 0) {
                initial_time = initial_time / 1000;
            }
            return initial_time;
        },
        getNowDate() { //获取服务器当前时间，如果获取失败则获取当前系统时间
            const this_ = this;
            this.$store.dispatch("getNowTime")
                .then((res) => {
                    if (res.code == 0) {
                        this.getNowTime = new Date(res.data).getTime();
                    } else {
                        this.getNowTime = new Date().getTime();
                    }
                }).catch(function (error) {
                    this_.getNowTime = new Date().getTime();
                });
            clearInterval(this.setInt); //先停止 避免出现多个定时器同时存在。
            this.setInt = setInterval(() => {
                this_.getNowTime = Number(this_.getNowTime) + 1000; //用于记录视频什么时候观看到什么位置
            }, 1000);
        },
        //加载视频信息 【慕课网】
        loadMoocVideo(tag) {
            var autoStart = false;
            if(tag == 2){
                if (Number(this.videoMap[this.onNum + "url"].courseVideoTime) <= (1000 * 60 * 21) || this.value) {
                    autoStart = true;
                } else { //大于20分钟时间 只有廊坊交通运输学校自动播放
                    if (this.$baseUrl.indexOf("lfjtysxx") >= 0) { //只有廊坊交通运输学校
                        autoStart = true;
                    }
                }
            }else{
                autoStart = true;
            }
            this.optionsInfo = {
                parent : document.getElementById('video'),
                autoStart : autoStart,
                forbiddenSeek:false,
            	appId:this.options.appId, //产品appId，详见参数说明
            	nonce: this.options.nonce, //随机数，详见参数说明
            	signature: this.options.signature, //签名，详见参数说明
            	timestamp: this.options.timestamp, //时间戳随机数，详见参数说明
            	uid:"", // 第三方用户id，详见参数说明
            	videoData:{
            		videoId: this.moocVideoId, // 从后端获取，详见参数说明
            		signature:this.options.videoSignature
            	}
            };
            this.moocPlayer = EduPlayer.create(this.optionsInfo);

            this.moocPlayer.$on('onMeta', (e)=> { //视频开始加载
                let time = this.getInitialTime(this.videoMap[this.onNum + "url"].active); //获取当前视频播放位置
                if (time != 0 && !this.$isEmpty(time)) {
                    this.moocPlayer.seek(time); //从哪里开始播放
                }

                if(this.openProgressBar == 1 && (this.$lookVideo([this.videoMap[this.onNum + "url"]]) || this.courseInfoLog[`${this.active}`] == 'OK')){ //表示已播放 完成  展示进度条
                    jQuery('.m-progressbar').show();//显示进度条
                }else{
                    jQuery('.m-progressbar').remove();//隐藏进度条
                    // jQuery('.m-progressbar').show();//显示进度条
                }
                const videoInfo = this.videoMap[this.onNum + 'url']
                if (videoInfo != null && videoInfo.tePlanCourseId != null) {
                    this.$getMessageAccept(videoInfo.tePlanCourseId);
                }
            })

            this.moocPlayer.$on('onTimeupdate', (e)=> { //播放时调用
                // console.log('视频播放时间');
                // console.log(e);
                // this.moocPlayer.play(); //播放
                // this.moocPlayer.pause(); //暂停

                //根据timeInterval进行分片  【开始】
                if (e.currentTime > 0 && this.getNowTime % 1000 == 0 && this.onOldTime < this.getNowTime) { //一秒一次
                    this.onOldTime = this.getNowTime;
                    const currentTime = Math.floor(e.currentTime);
                    if(currentTime % this.timeInterval == 1){ //写入分片开始值
                        this.nextTime = currentTime - 1;
                    }
                    if(currentTime % this.timeInterval == 0 && this.isNewSave){ //到上传播放记录的时候啦
                        if(currentTime - this.nextTime == this.timeInterval){ //对了 对了  当前时间-分片上次的时间 = 设置的间隔时间
                            const paramLog = {
                                startTime:this.nextTime * 1000,
                                endTime:currentTime * 1000,
                                tePlanCourseVideoId:this.videoMap[this.onNum + "url"].tePlanCourseVideoId,
                                url:this.videoMap[this.onNum + "url"].url,
                                courseVideoTime:Math.floor(this.videoMap[this.onNum + "url"].courseVideoTime)
                            }
                            this.saveLog(paramLog);
                        }
                    }
                }
                if (e.currentTime == e.duration && this.isNewSave) { //播放完成
                    this.nextTime = e.duration - (e.currentTime % this.timeInterval);
                    const paramLog = {
                        startTime:this.nextTime * 1000,
                        endTime:Math.floor(this.videoMap[this.onNum + "url"].courseVideoTime),
                        tePlanCourseVideoId:this.videoMap[this.onNum + "url"].tePlanCourseVideoId,
                        url:this.videoMap[this.onNum + "url"].url,
                        courseVideoTime:Math.floor(this.videoMap[this.onNum + "url"].courseVideoTime)
                    }
                    this.saveLog(paramLog);
                }
                //根据timeInterval进行分片  【结束】

                if (e.currentTime > 0 && this.getNowTime % 2000 == 0 && this.oldTime < this.getNowTime) {
                    this.oldTime = this.getNowTime;

                    //判断是否出现了弹出系统消息对话框  ， 如果出现了则停止视频播放
                    let newTag = localStorage.getItem(getStorageKeyForRoleTag("new_index_tag")); //表是已有页面展示了消息对话框
                    if (newTag == "OK") {
                        (typeof this.moocPlayer.pause === 'function') && this.moocPlayer.pause(); //暂停视频
                        return;
                    }
                }
                if (e.currentTime > 5) {
                    //当前课程的播放时间记录
                    if (!this.$isEmpty(localStorage.getItem(getStorageKeyForRoleTag("courseTimeMap_") + this.tePlanCourseId))) {
                        this.courseTimeMap = JSON.parse(localStorage.getItem(getStorageKeyForRoleTag("courseTimeMap_") + this.tePlanCourseId));
                        if (this.courseTimeMap == null || this.courseTimeMap == "") {
                            this.courseTimeMap = {};
                        }
                    }
                    this.getAndSetTime(this.active, Math.floor(e.currentTime) * 1000); //同步至当前页面课程树结构list
                    this.courseTimeMap[`${this.active}`] = Math.floor(e.currentTime); //存入当前播放的位置
                    localStorage.setItem(getStorageKeyForRoleTag("courseTimeMap_") + this.tePlanCourseId, JSON.stringify(this.courseTimeMap));
                    // sessionStorage.setItem("currentTime_"+this.onNum,Math.floor(e.currentTime)); //临时存储当前播放的时间根据位置存储
                }
                if (e.currentTime == e.duration || (Number(e.currentTime) + 5) >= e.duration) { //时间相等说明播放完毕  && this.value  【为什么加上5秒，是因为反显时，相差5秒也会显示已完成】
                    //是否播放完成的标记
                    if (!this.$isEmpty(localStorage.getItem(getStorageKeyForRoleTag("courseInfoLog_") + this.tePlanCourseId))) {
                        this.courseInfoLog = JSON.parse(localStorage.getItem(getStorageKeyForRoleTag("courseInfoLog_") + this.tePlanCourseId));
                        if (this.courseInfoLog == null || this.courseInfoLog == "") {
                            this.courseInfoLog = {};
                        }
                    }
                    this.courseInfoLog[`${this.active}`] = "OK"; //表示已播放完成
                    localStorage.setItem(getStorageKeyForRoleTag("courseInfoLog_") + this.tePlanCourseId, JSON.stringify(this.courseInfoLog));
                    if (e.currentTime == e.duration){
                        if (this.getCurrentFaceConfig.courseOutstate === 1) {
                            console.log("播放完成时开启人脸识别！")
                            //根据配置决定是否在播放完成后开启人脸识别
                            this.visibleFaceModal = true;
                            this.$forceUpdate();
                        }
                        if (!this.$isEmpty(this.videoMap[((Number(this.onNum) + 1) + '') + "url"])) {
                            this.onNum = Number(this.onNum) + 1;
                            if (!this.$isEmpty(this.videoMap[this.onNum + "url"].url)) {
                                this.active = this.videoMap[this.onNum + "url"].active + '';
                                let time = this.getInitialTime(this.active);
                                this.heaLoad(this.videoMap[this.onNum + "url"].url, time, 2);
                            } else {
                                this.onNum = Number(this.onNum) - 1;
                            }
                        }
                    }
                }
            });
        },
        saveLog(param){ //新的保存视频播放记录方法
          param.studentId = this.studentId;
          this.$store.dispatch("user/newSaveVideosLog", param).then((res) => {
            // console.log("调用了新的上传："+param)
          }).catch((error) => {
             // console.log("调用了新的上传失败："+error)
          });
        },
        getOptions(tag) {
            this.$store.dispatch("user/getVideoCreateInfo", {
        		moocVideoId:this.moocVideoId
            }).then((ret) => {
                if(ret.code  == 0){
                    this.options = ret.data;
                    this.loadMoocVideo(tag);
                }
            }).catch(() => {});
        },
    },
    beforeDestroy(key) {
        if (this.player) {
            this.player.dispose();
        }
        if (this.moocPlayer) {
            this.moocPlayer.destroy();
        }
    },
    destroyed() {
        clearInterval(this.timer_intervalFaceCheck);
    },
};
</script>
<style lang="less">
@import '../../styles/base.less';

.videoOffset {
    margin-left: 50%;
    transform: translateX(-50%);
}

video {
    object-fit: contain !important;
}

.el-StudyAuthentication {
    .el-submenu .el-menu-item {
        padding: 0 20px;
        padding-left: 40px !important;
    }

    .el-menu-item,
    .el-submenu__title {
        font-size: 14px;
        padding: 0 10px;
    }

    .head_title_white {
        text-align: right;
        margin-bottom: 0;
        padding: 10px 30px;
    }

    .head_title {
        margin: 0;
        font-size: 18px;
        border-bottom: 1px solid white;

    }

    .bg_ {
        height: 10px;
        background-color: @mainBg;
        margin: 0 -20px;
    }

    .el-main {
        // min-width: 1200px;
    }

    .el-dialog {
        border-radius: 10px;
    }

    .zdlb {
        border-radius: 5px;
        background-color: white;
        float: right;
        color: #909399;
        font-size: 12px;
        height: 40px;
        line-height: 40px;
        padding: 0 10px;
        margin-top: -6px;
    }

    .jd {
        color: #67c23a;
        float: right;
        margin-right: 10px;
    }

    .jxz {
        background: #67c23a;
        padding: 8px;
        display: block;
        float: right;
        border-radius: 50%;
        margin-right: 10px;
        margin-top: 20px;
    }

    .wx {
        padding: 7px;
        display: block;
        float: right;
        border-radius: 50%;
        margin-right: 10px;
        margin-top: 20px;
        border: 1px solid #909399;
    }

    .ywc {
        float: right;
        line-height: 50px;
        color: white;
    }

    .el-main {
        background-color: white;
        padding: 0 !important;
        margin-left: 10px !important;
    }

    .el-menu-vertical-demo {
        height: calc(100vh - 230px);
        min-height: 400px;
        overflow: auto;
        border: solid 1px #e6e6e6;
        border-top: none;
    }

    // 自定义工具栏样式
    // .vjs-progress-control,
    // .vjs-picture-in-picture-control {
    //     //隐藏进度条
    //     display: none !important;
    // }

    .vjs-remaining-time,
    .vjs-picture-in-picture-control,
    .vjs-fullscreen-control {
        float: right;
    }

    //慕课
    .ux-video-player ul{
        margin: 0;
        padding: 0;
        text-align: center;
    }
    .u-edu-h5player-controlwrap .m-popover-rate li{
        width: 100%;
    }
    .m-popover li{
        padding-left: 0;
    }
    .g-right{
        display: none;
    }



    .el-menu-item.is-disabled{
        opacity: 0.55 !important;
    }
}
</style>



// WEBPACK FOOTER //
// src/pages/learningCenter/StudyAuthentication.vue